/* eslint-disable no-unused-vars */
import { Box, fade, Grid, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import ReactECharts from 'echarts-for-react';
import { CHART_TYPES } from './constants';
import ChartButtons from './ChartButtons';
import { generateLineTypeChartData } from './helpers';
import Skeleton from '@material-ui/lab/Skeleton';
import {
  getCharts,
  updateCharts,
} from '../../redux_store/reducer/reducers/chartsReducer';

const useStyles = makeStyles((theme) => ({
  chartBox: {
    width: '100%',
    height: 336,
    border: `1px solid ${fade(theme.palette.common.black, 0.12)}`,
    borderRadius: theme.shape.borderRadius,
  },
  shimmer: {
    margin: theme.spacing(4, 0),
    width: '100%',
    height: 1000,
  },
}));

const Charts = () => {
  const { en } = useSelector((state) => state.i18n);
  const dispatch = useDispatch();
  const classes = useStyles();
  const { charts } = useSelector((state) => state.charts);
  const { metrics } = useSelector((state) => state.charts);
  const chartData = metrics?.chartData;
  const { isInfoPaneExpanded } = useSelector((state) => state.infoPane);

  useEffect(() => {
    dispatch(getCharts());
  }, []);

  return (
    <Grid container spacing={4}>
      {!chartData && <Skeleton variant='rect' className={classes.shimmer} />}
      {chartData && charts && charts.map(({ key, chartType, chartDate }) => {
        const data = chartData ? generateLineTypeChartData(
          en.charts[key],
          get(chartData, key, []).map(({ name, value }) => ({
            value,
            name: en.charts[name],
          })),
          chartType,
        ) : {};
        return (
          <Grid
            style={{
              position: 'relative',
            }}
            item
            lg={isInfoPaneExpanded ? 12 : 6}
            md={12}
            xs={12}
            sm={12}
          >
            <ChartButtons
              chartType={chartType}
              chartDate={chartDate}
              setCharts={(newCharts) => dispatch(updateCharts(newCharts))}
              charts={charts}
              dataKey={key}
            />
            <Box className={classes.chartBox}>
              {chartType === CHART_TYPES.PIE && <_PieCharts data={data}/>}
              {chartType === CHART_TYPES.BAR && <_BarCharts data={data}/>}
              {chartType === CHART_TYPES.LINE && <_LineCharts data={data}/>}
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default Charts;


// The data is cached and the scale from the linear diagrams is displayed for the circular diagram
// Therefore, we force the widget to re-draw
const _PieCharts = ({data}) => {
  const [canRender, setCanRender] = useState(false);

  useEffect(() => {
    // prevent errors with charts (if you render with data - nothing displayed, firstly we render with null)
    setCanRender(true)
  }, []);

  return <ReactECharts
    key={'pie'}
    style={{ height: 400 }}
    opts={{ renderer: 'svg' }}
    option={canRender ? data : {}}
  />;
};

const _LineCharts = ({data}) => {
  const [canRender, setCanRender] = useState(false);

  useEffect(() => {
    // prevent errors with charts (if you render with data - nothing displayed, firstly we render with null)
    setCanRender(true)
  }, []);

  return <ReactECharts
    key={'liner'}
    style={{ height: 330 }}
    opts={{ renderer: 'svg' }}
    option={canRender ? data : {}}
  />;
};

const _BarCharts = ({data}) => {
  const [canRender, setCanRender] = useState(false);

  useEffect(() => {
    // prevent errors with charts (if you render with data - nothing displayed, firstly we render with null)
    setCanRender(true)
  }, []);

  return <ReactECharts
    key={'bar'}
    style={{ height: 330 }}
    opts={{ renderer: 'svg' }}
    option={canRender ? data : {}}
  />;
};

